
// @module ProductDetails
define('Code25.ProductOptions.View', [

    'Backbone.CompositeView', "LW.MultiPL.Model", 'ProductViews.Price.View', 'ProductLine.Stock.View', 'ProductLine.StockDescription.View', 'c25_productoptions.tpl', 'Utils', 'Backbone', 'SocialSharing.Flyout.View', 'LiveOrder.Line.Model', 'LiveOrder.Model', 'Cart.Confirmation.Helpers', 'ProductDetails.AddToProductList.View', 'Tools', 'ProductList.Utils'
], function (

    BackboneCompositeView, Code25MultiPLModel, ProductViewsPriceView, ProductLineStockView, ProductLineStockDescriptionView, c25_productoptions_tpl, Utils, Backbone, SocialSharingFlyoutView, LiveOrderLineModel, LiveOrderModel, CartConfirmationHelpers, ProductDetailsAddToProductListView, Tools, ProductListUtils
) {
    'use strict';

    //@class ProductOptionsTable.View.initialize
    //@property {Transaction.Line.Model} model

    //"ProductList.Control.View"

    return Backbone.View.extend({

        //@property {Function} template
        template: c25_productoptions_tpl

        //@method initialize Override default method to made current view composite
        //@param {ProductOptionsTable.View.initialize} options
        //@return {Void}
        ,
        initialize: function (options) {
            Backbone.View.prototype.initialize.apply(this, arguments);
            BackboneCompositeView.add(this);
            this.application = options.application;
            this.cart = LiveOrderModel.getInstance();

            var self = this;

            Backbone.on('vatTaxes:change', function (action, ctx) {
                self.render();
            });
            if (ProductListUtils.ProductListUtils) {
                ProductListUtils = ProductListUtils.ProductListUtils;
            }
            this.productListModule = new ProductListUtils(this.options.application);
            this.isProductListEnabled = this.productListModule.isProductListEnabled();
            if (this.isProductListEnabled) {
                this.productListsPromise = this.productListModule.getProductListsPromise();
            } else {
                this.productListsPromise = jQuery.Deferred();
            }
        },
        events: {
            'click [data-action="updateMatrixQuantity"]': 'setMatrixQuantity',
            'click [data-action="changeMatrixQuantity"]': 'setMatrixFocus',
            'keyup [data-action="changeMatrixQuantity"]': 'disableMatrixFocus',
            'click [data-action="addtocart"]': 'addToCart',
            'click [data-action="add-to-quote"]': 'addToQuote',
            'click [data-action="add-to-wishlist"]': 'addToWishlist'
        } //@method showErrorInModal @param  {String} message
        , addToQuote: function (e) {
            this.addToMultiPL("quote");
        }
        , addToWishlist: function (e) {

            if (this.isProductListEnabled) {
                var product_list_collection = this.productListModule.getProductLists();
                console.log(product_list_collection);

                this.addToMultiPL("saved items");
            }
        }
        , addToMultiPL: function (task) {
            var self = this;

            var datainternalid, quantity, data = "";
            this.$(".product-details-quantity-value").each(function () {
                quantity = parseInt($(this).val());
                if ($(this).val() == "") {
                    quantity = 0;
                }
                datainternalid = $(this).attr("data-internalid");

                if (quantity > 0) {
                    if (data) {
                        data += ",";
                    }
                    data += datainternalid + "," + quantity;
                }
            });
            if (!data) {
                self.successMessage(task, "Please select some item quantities to add to " + task + ".");
                return;
            }
            var model = new Code25MultiPLModel();

            model.fetch({
                data: {
                    list: data,
                    task: task
                },
                success: function (res) {
                    // console.log("res", res);
                    if (model.get("ok")) {

                        self.successMessage(task, "Items added.");
                        // if(task=="saved items"){
                        //   console.log( self.productListModule);

                        //   this.getEmitter().emit('entriesChanged');
                        // }
                    } else {
                        self.successMessage(task, model.get("error") || "Unknown error.");
                    }


                },
                error: function (err, err2) {
                    if (err2) {
                        err = err2;
                    }
                    var responseJSON = err && err.responseJSON;
                    //console.log(responseJSON);
                    var order = LiveOrderModel.getInstance();
                    order.fetch();

                    if (responseJSON && responseJSON.errorStatusCode == "500") {
                        if (responseJSON.errorMessage && (responseJSON.errorMessage.indexOf("internal error") > -1 || responseJSON.errorMessage.indexOf("Gateway") > -1 || responseJSON.errorMessage.indexOf("proxy") > -1)) {
                            self.successMessage(task, "The items could not be added to the " + task + ". The connection to the server failed or took too long. Check your internet connection, try uploading a shorter files, wait and try again.");
                        } else {
                            self.successMessage(task, responseJSON.errorMessage);
                        }
                    } else {
                        self.successMessage(task, (err || "").toString());
                    }
                    console.log("err", err);
                }
            });
        }, successMessage: function (task, message) {
            Tools.showErrorInModal(this.application, Utils.translate('Add to ' + task), Utils.translate(message));
        }
        ,
        showErrorInModal: function (title, message) {
            var view = new Backbone.View({ application: this.application });

            view.title = title;
            view.render = function () {
                this.$el.append('<p class="error-message">' + message + '</p>');
            };
            view.showInModal();
        },
        addToCart: function (e) { //Add all selected items to the cart

            e.preventDefault();
            var self = this;

            var matrixquantities = this.model.get("matrixquantities");
            var minimum_quantity = this.model.get('item').get('_minimumQuantity') || 0;

            if (!matrixquantities) {
                matrixquantities = {};
            }
            var totalquantity = 0,
                optionlist = [];
            var item_matrix_children = this.model.get('item').get('_matrixChilds');
            var options = this.model.getVisibleOptions();
            var newOption;
            for (var q in matrixquantities) { //Find the quantities and models and put them in a list.
                if (matrixquantities[q] > 0) {
                    totalquantity += matrixquantities[q];
                    newOption = { itemid: q, quantity: matrixquantities[q] };
                    optionlist.push(newOption);
                    for (var j = 0; j < item_matrix_children.models.length; j++) {
                        if (item_matrix_children.models[j].get("itemid") == q) {
                            console.log("Found " + q);
                            newOption.model = item_matrix_children.models[j];
                        }
                    }

                }
            }
            if (totalquantity < minimum_quantity) { //Needs more items.
                Tools.showErrorInModal(this.application, Utils.translate('Unable to Add to Basket'), Utils.translate('Please select $(0) or more items.', minimum_quantity));
                return;
            }
            var line, lineoptions, lines = [];
            var cartOptionId, itemOptionId, values, label;
            //fist set the options on the model
            for (var i = 0; i < optionlist.length; i++) {

                lineoptions = this.model.get("options");
                //console.log("lineoptions: "+JSON.stringify(lineoptions));

                for (var j = 0; j < lineoptions.models.length; j++) {
                    cartOptionId = lineoptions.models[j].get("cartOptionId");
                    itemOptionId = lineoptions.models[j].get("itemOptionId");
                    label = optionlist[i].model.get(itemOptionId);
                    values = lineoptions.models[j].get("values");
                    for (var k = 0; k < values.length; k++) {
                        if (values[k].label == label) {
                            lineoptions.models[j].set("value", {
                                "internalid": values[k].internalid,
                                "label": label
                            });
                            lineoptions.models[j].set("value.internalid", values[k].internalid);
                            lineoptions.models[j].set("value.label", label);
                            break;
                        }
                    }
                }
                //console.log("lineoptions b: "+JSON.stringify(lineoptions));
                //then convert the model to a line.
                line = LiveOrderLineModel.createFromProduct(this.model);
                line.set("quantity", optionlist[i].quantity);



                lines.push(line);
            }

            //console.log("Test: " + JSON.stringify(lines));
            //add list of lines to cart.
            var cart_promise = this.cart.addLines(lines);
            //return;

            CartConfirmationHelpers.showCartConfirmation(cart_promise, lines, self.application);


            cart_promise.fail(function (jqXhr) {
                var error_details = null;
                try {
                    var response = JSON.parse(jqXhr.responseText);
                    error_details = response.errorDetails;
                } finally {
                    if (error_details && error_details.status === 'LINE_ROLLBACK') {
                        self.model.set('internalid', error_details.newLineId);
                    }
                }

            });

            this.disableElementsOnPromise(cart_promise, e.target);
            return false;

        },
        setQuantity: function (id, quantity) { //Save the quantity onto the model object. Because that's how it currently works.
            var matrixquantities = this.model.get("matrixquantities");
            if (!matrixquantities) {
                matrixquantities = {};
                this.model.set("matrixquantities", matrixquantities)
            }
            matrixquantities[id] = quantity;
        },
        validateMatrix: function (e) { //Go through all the matrix values and validate them against min max etc.
            var total = 0,
                totalprice = 0;
            var minimum_quantity = this.model.get('item').get('_minimumQuantity') || 0;

            var self = this,
                $StockNotes, quantityavailable;
            this.$(".product-details-quantity-value").each(function () {
                var quantity = parseInt($(this).val());
                if ($(this).val() == "") {
                    quantity = 0;
                }
                self.setQuantity($(this).attr("data-id"), quantity);


                $StockNotes = $(this).closest(".productoptions-td-row").find(".stock-notes");
                if ($StockNotes.length > 0) {

                    quantityavailable = parseInt($StockNotes.attr("data-quantityavailable"));
                    if (quantityavailable < quantity) {
                        $StockNotes.show();
                    } else {
                        $StockNotes.hide();
                    }
                }
                if (!_.isNumber(quantity) || _.isNaN(quantity) || quantity < 0) {

                } else {
                    if (quantity > 0) {
                        total += quantity;
                        totalprice += quantity * parseFloat($(this).attr("data-price"));
                    }
                }

            });
            $("#ProductOptionsQuantity").html(total);
            $("#ProductOptionsTotal").html(Utils.formatCurrency(totalprice));




        },
        findMatrixInput: function (e) { //Find the relevant input based on clicks or buttons.
            return this.$(e.target).closest(".product-details-quantity-container").find("[name='matrixquantity']");
        },
        findMatrixRemove: function (e) { //Find the relevant remove button based on clicks or buttons.
            return this.$(e.target).closest(".product-details-quantity-container").find(".product-details-quantity-remove");
        }

        // @method setQuantity Increase the product's Quantity by 1
        // @param {jQuery.Event} e
        // @return {Void}
        ,
        setMatrixQuantity: function setQuantity(e) {
            e.preventDefault();
            var $input = this.findMatrixInput(e);
            var value = parseInt(this.$(e.currentTarget).data('value'), 10),
                old_value = parseInt($input.val(), 10),
                new_quantity = old_value + value;


            $input.val(new_quantity).trigger('blur');

            var $remove = this.findMatrixRemove(e);
            if (new_quantity > 0) {
                $remove.prop('disabled', false);
            } else {
                $remove.prop('disabled', true);
            }
            this.validateMatrix(e);
        }

        // @method setFocus sets focus on input when clicked. Needed as FF won't focus if quantity is updated from spinners
        // @return {Void}
        ,
        setMatrixFocus: function setFocus(e) {
            var $input = this.findMatrixInput(e);
            $input.focus();
            this.validateMatrix(e);
        }

        // @method disableFocus Blur if ENTER/RETURN key is pressed
        // @return {Void}
        ,
        disableMatrixFocus: function disableFocus(e) {
            if (e.keyCode === 13) {
                var $input = this.findMatrixInput(e);
                $input.blur();
            }
            this.validateMatrix(e);
        }

        //@method render Override default method to made current view composite
        //@param {ProductOptionsTable.View.render}
        //@return {Void}
        ,
        render: function () {
            if (!this.model.get('options').length) {
                return;
            }

            this._render();
        }
        //@property {ChildViews} childViews
        ,
        childViews: {

            'Item.Price': function () {
                return new ProductViewsPriceView({
                    model: this.model,
                    origin: 'PDPOPTIONS'
                });
            },
            'Item.Stock': function () {
                return new ProductLineStockView({
                    model: this.model
                });
            },
            'StockDescription': function () {
                return new ProductLineStockDescriptionView({
                    model: this.model
                });
            },
            'SocialSharing.Flyout': function () {
                return new SocialSharingFlyoutView({});
            },
            'AddToProductList': function () {
                return new ProductDetailsAddToProductListView({
                    model: this.model,
                    application: this.application
                });
            }
        }
        , getNumber: function (value) {
            if (value) {
                var c, body = "", hasNumber;
                for (var i = 0; i < value.length; i++) {
                    c = value.charAt(i);
                    if (c >= '0' && c <= '9') {
                        hasNumber = true;
                        body += c;
                    } else if (hasNumber && c == ".") {
                        body += c;
                    }
                }
                if (body.length > 0) {
                    return parseInt(body);
                }
            }
            return value;
        }
        ,
        compareValue: function (A, B) {

            var Anum = this.getNumber(A);
            var Bnum = this.getNumber(B);

            var isAnum = typeof (Anum) == "number";
            var isBnum = typeof (Bnum) == "number";

            if (isAnum && !isBnum) {
                return false;
            } else if (!isAnum && isBnum) {
                return true;
            } else if (isAnum && isBnum) {

                return Anum > Bnum;
            }
            return A > B;

        }
        ,
        getRowValue: function (row, name) {
            if (name && row && row.values) {
                for (var i = 0; i < row.values.length; i++) {
                    if (row.values[i].label == name) {

                        return row.values[i].value;
                    }
                }
            }
        },
        getPrice: function (isActive, child) {

            var vatTaxes = (SC.CONFIGURATION && SC.CONFIGURATION.VATTaxes && SC.CONFIGURATION.VATTaxes.config) || [];

            var itemTax = child.get("taxschedule");
            var onlinecustomerprice = child.get("onlinecustomerprice_detail").onlinecustomerprice;

            var selectedTax = _.find(vatTaxes, function (tax) {
                return tax.type.toLowerCase().trim() === itemTax.toLowerCase().trim();
            });
            if (selectedTax) {
                var taxRate = selectedTax.rate;

                if (!isActive) {

                    return onlinecustomerprice / (1 + (taxRate / 100));

                }
            }
            return onlinecustomerprice;


        }
        //@method getContext
        //@return {ProductOptionsTable.View.Context}
        ,
        getContext: function () {

            var isActive = $('.toggle-switch').hasClass('active');
            var taxLabel = isActive ? 'Incl. VAT' : 'Ex. VAT';

            //Load all the matrix options into a list that's easy to render.
            var options = this.model.getVisibleOptions();


            // var facet1 = this.model.get("item").get("custitem_c25_sortfacet1");
            // var facet2 = this.model.get("item").get("custitem_c25_sortfacet2");
            var facet3;
            var columns = [];
            for (var i = 0; i < options.length; i++) {
                columns.push({
                    cartOptionId: options[i].get("cartOptionId"),
                    itemOptionId: options[i].get("itemOptionId"),
                    label: options[i].get("label"),
                    type: options[i].get("type"),
                    isMatrixDimension: options[i].get("isMatrixDimension")
                });

            }


            var item_matrix_children = this.model.get('item').get('_matrixChilds');

            var today = new Date();
            today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            var rows = [],
                row, value, child, showoutofstockmessage, ispurchasable, showprices = true,
                lastprice, outofstockmessage, quantityavailable, leadtime, comparePrice;


            for (var i = 0; i < item_matrix_children.length; i++) {
                child = item_matrix_children.models[i];

                if (child.get("pricelevel1") > child.get("onlinecustomerprice_detail").onlinecustomerprice) {
                    comparePrice = child.get("pricelevel1_formatted");
                } else {
                    comparePrice = "";
                }

                //hard coded, allways show a stock message.
                outofstockmessage = child.get("outofstockmessage");
                quantityavailable = child.get("quantityavailable");


                if (quantityavailable > 0) { //In stock
                    outofstockmessage = "<span class=\"productoptions-instock\">" + Utils.translate("In Stock") + "</stan>";
                    //outofstockmessage += "<div data-quantityavailable='" + quantityavailable + "'class='stock-notes'>" + Utils.translate("Note: Only $(0) in Stock.", quantityavailable) + "<br />";

                    //not enough stock messages
                    // var remaindermessage;

                    // outofstockmessage += (remaindermessage || "") + "</div>";


                } else { //Out of stock
                    outofstockmessage = "<span class=\"productoptions-outofstock\">" + Utils.translate("Available for Backorder") + "</span>";

                }

                row = {model:child, values: [], outofstockmessage: outofstockmessage, showoutofstockmessage: outofstockmessage != null, ispurchasable: child.get("ispurchasable"), itemid: child.get("itemid"), internalid: child.get("internalid"), price_formatted: Utils.formatCurrency(this.getPrice(isActive, child)), price: this.getPrice(isActive, child), comparePrice: comparePrice };

                row.quantity = 0;
                rows.push(row);
                if (row.showoutofstockmessage) {
                    showoutofstockmessage = true;
                }
                if (child.get("ispurchasable")) {
                    ispurchasable = true;
                }

                lastprice = row.price;
                for (var j = 0; j < columns.length; j++) {

                    value = { label: columns[j].label, value: child.get(columns[j]["itemOptionId"]) };
                    if (columns[j]["itemOptionId"] == "custitem_matrix_colour" && value.value) {
                        value.value = "<span class=\"colour-base colour-" + value.value + "\">" + value.value.split(" ").join("") + "</span>";
                    }
                    row.values.push(value);
                }
            }

            //sort by code then price.
            var swap, change = false;
            do {
                change = false;
                for (var i = 0; i < rows.length - 1; i++) {

                    if (parseInt(rows[i].itemid) > parseInt(rows[i + 1].itemid)) {
                        change = true;
                        swap = rows[i];
                        rows[i] = rows[i + 1];
                        rows[i + 1] = swap;
                    }
                }
            } while (change);
            do {
                change = false;
                for (var i = 0; i < rows.length - 1; i++) {
                    if (rows[i].price > rows[i + 1].price) {
                        change = true;
                        swap = rows[i];
                        rows[i] = rows[i + 1];
                        rows[i + 1] = swap;
                    }
                }
            } while (change);

            //work out if columns will wrap.
            var totalcolumns = (columns.length * 1) + 1;
            if (showprices) {
                totalcolumns += 2;
            }
            if (ispurchasable) {
                totalcolumns += 3;
            }
            if (showoutofstockmessage) {
                totalcolumns += 2;
            }

            //console.log(totalcolumns + " " + columns.length + " " + ispurchasable + " " + showprices);
            //console.log(item_matrix_children);

            //@class ProductOptionsTable.View.Context


            return {
                columns: columns,
                rows: rows,
                //@property {ProductModel} model
                model: this.model,
                showoutofstockmessage: showoutofstockmessage,
                ispurchasable: ispurchasable,
                showprices: showprices,
                iswrapped: totalcolumns > 12,
                wrapclass: totalcolumns > 12 ? " wrapped" : "",
                taxLabel: taxLabel
                // ,
                // deliveryMessage: Tools.getDeliveryMessage(),
                // deliveryMessageTime: Tools.getDeliveryMessageTime()

            };
            //@class ProductOptionsTable.View
        }

    });
});

